import { render, staticRenderFns } from "./DefinedTerm.vue?vue&type=template&id=ae3af220"
import script from "./DefinedTerm.vue?vue&type=script&lang=js"
export * from "./DefinedTerm.vue?vue&type=script&lang=js"
import style0 from "./DefinedTerm.vue?vue&type=style&index=0&id=ae3af220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports